import React from 'react'
import styled from 'styled-components/macro'
import { Header2, Row, Spaced } from '.'
import { Employee } from '../services/useEmployees'
import { EmployeeCard } from './EmployeeCard'
import { Line } from './Line'

export const EmployeeSection: React.FC<{ group: string; employees: ReadonlyArray<Employee> }> = ({
  employees,
  group,
  ...restProps
}) => (
  <section id={group} {...restProps}>
    <Spaced bottom steps={2}>
      <Row align="center">
        <Spaced right steps={1.5}>
          <Header2>{group}</Header2>
          <Line />
        </Spaced>
      </Row>

      <EmployeesList>
        {employees.map((employee) => (
          <EmployeeCard key={employee.Email} {...employee} />
        ))}
      </EmployeesList>
    </Spaced>
  </section>
)

const EmployeesList = styled.div`
  display: flex;
  flex-wrap: wrap;

  justify-content: center;

  & > div {
    margin-bottom: calc(2 * 24px);
    margin-right: 10px;
  }

  /* When container is small enough that only one card can fit in a row, align cards center screen */
  @media (min-width: 621px) {
    justify-content: flex-start;
  }
`
